import { env } from '@/config/env'

export {
  MIN_SIGNAL_PROVIDERS as DEFAULT_RESPONSE_TARGET,
  MIN_SIGNAL_PROVIDERS as MIN_RESPONSE_TARGET,
} from '@/features/instruments/publish/target-audience/lib/audienceTypes'

/** Minimum reward per response (USD) — `VITE_MIN_REWARD_USD`, default 1. */
export const MIN_REWARD_USD = env.VITE_MIN_REWARD_USD

export type BudgetWizardTab = 'response_target' | 'reward_per_response' | 'campaign_budget'

export const BUDGET_WIZARD_TABS = [
  'response_target',
  'reward_per_response',
  'campaign_budget',
] as const satisfies readonly BudgetWizardTab[]

export interface BudgetTabConfirmations {
  responseTarget: boolean
  rewardPerResponse: boolean
  campaignBudgetViewed: boolean
}

export const EMPTY_TAB_CONFIRMATIONS: BudgetTabConfirmations = {
  responseTarget: false,
  rewardPerResponse: false,
  campaignBudgetViewed: false,
}

export const FUTURE_OPTIONAL_RESPONSE_TARGET_HELPER =
  'Adding a target allows the instrument to automatically close once the target number of completed responses is reached.'
